import client, { unwrap } from './client';

export const getProfitSettings = () =>
  client.get('/profit-pulse/settings').then(unwrap);

export const updateProfitSettings = (body) =>
  client.patch('/profit-pulse/settings', body).then(unwrap);
